import { SESSION_KEY, AZFN_GET_EVENTS } from "../common/constants"
import axios from "axios"
import { getCached, setCached } from "@utilities"

export const getEvents = async () => {
  let eventsData = getCached(SESSION_KEY.EVENTS)
  if (!eventsData) {
    const response = await axios.get(`${AZFN_GET_EVENTS}`)
    eventsData = response.data
    setCached(SESSION_KEY.EVENTS, eventsData)
  }
  return eventsData
}
